__turbopack_context__.v({
  "className": "fraunces_9e5076b3-module__B2F4dq__className",
});
